<template>
  <b-container class="app-booked-options-table">
    <div class="summary-data-costs">
      <b-row class="data-line thead">
        <b-col class="data-cell first" ><slot name="txtOptionsHeader">Paket</slot></b-col>
        <b-col class="data-cell second"><slot name="txtSMS">Min/&shy;SMS</slot></b-col>
        <b-col class="data-cell third"><slot name="txtGB">GB</slot></b-col>
        <b-col class="data-cell fourth"><slot name="txtState">Status</slot></b-col>
        <b-col class="data-cell fifth"><slot name="txtDuration">Endet/&shy;Verlängert sich am</slot></b-col>
        <b-col class="data-cell sixth"><slot name="txtCosts">Preis</slot></b-col>
      </b-row>
      <hr>
    </div>

    <div v-if="options.length > 0">
      <div class="data-block-options" v-for="item in options" :key="item.id">
        <b-row class="data-line opts">
          <b-col class="data-cell first name">
            <div class="responsive-label"><slot name="col1Header">Paket</slot></div>
            <span v-html="item.name"></span>
          </b-col>
          <b-col class="data-cell second sms">
            <div class="responsive-label"><slot name="col2Header">Min/SMS</slot></div>
            <span>{{ getMinSMS(item) }}</span>
          </b-col>
          <b-col class="data-cell third gb">
            <div class="responsive-label"><slot name="col3Header">GB</slot></div>
            <span>{{ getGB(item) }}</span>
          </b-col>
          <b-col class="data-cell fourth state">
            <div class="responsive-label"><slot name="col4Header">Status</slot></div>
            <span v-html="item.state"></span>
          </b-col>
          <b-col class="data-cell fifth end-of-runtime">
            <div class="responsive-label"><slot name="col5Header">Endet/Verlängert sich am</slot></div>
            <span v-if="item.endOfRuntime">{{ toDate(item.endOfRuntime) }}</span>
            <span v-else><slot name="txtNoEndRuntime">-</slot></span>
          </b-col>
          <b-col class="data-cell sixth price">
            <div class="responsive-label"><slot name="col6Header">Preis</slot></div>
            <span v-if="item.price !== 0">{{ price(item.price) }}</span>
            <span v-else><slot name="txtForFree">-</slot></span>
          </b-col>
        </b-row>
        <hr>
      </div>
    </div>
    <div v-else>
      <slot name="txtNonOptions"></slot>
    </div>
  </b-container>
</template>

<script>
import price from '@/mixins/price'
import durationUnit from '@/mixins/durationUnit'

export default {
  name: 'MultipleOptionsTable',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    consumptions: {
      type: Array,
      default: () => []
    }
  },
  mixins: [
    price,
    durationUnit
  ],
  computed: {
    consumption_ () {
      return this.consumptions
    }
  },
  methods: {
    getGB (item) {
      return this.searchVolume(item, 'GB')
    },
    getMinSMS (item) {
      return this.searchVolume(item, 'QUANTITY')
    },
    searchVolume (item, type) {
      return item.volumes?.find(element => element.unit === type)?.amount || '-'
    },
    centsToEuros (value) {
      return this.$config.calendar.formatter.currencyFormatter.format(parseInt(value) / 100)
    },
    toDate (date) {
      return this.$config.calendar.formatter.dateFormatter.format(new Date(date))
    }
  }
}
</script>
